var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTier5Img(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 350,
    viewBox: "0 0 350 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.25,
    cx: 174.977,
    cy: 174.979,
    r: 146.616,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.802 94.1208L221.097 163.032",
    stroke: "#C4C4C4",
    strokeWidth: 9.73973,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.099 152.036L127.934 174.984",
    stroke: "#C4C4C4",
    strokeWidth: 9.73973,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.25,
    cx: 175,
    cy: 175,
    r: 170.13,
    stroke: "#C4C4C4",
    strokeWidth: 9.73973
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.864 79.0669C172.199 76.8904 175.322 76.8537 175.708 79.0217L193.881 181.169C194.54 184.872 195.908 188.414 197.909 191.599L234.898 250.455C236.029 252.254 233.873 254.306 232.132 253.088L190.402 223.888C180.343 216.849 166.957 216.849 156.898 223.888L115.784 252.657C114.018 253.892 111.85 251.77 113.048 249.978L151.699 192.167C154.073 188.616 155.639 184.589 156.288 180.367L171.864 79.0669Z",
    fill: "#C4C4C4"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTier5Img);
export default __webpack_public_path__ + "static/media/tier-5-img.e8b81fbc215dac7586b7793f3427f1fe.svg";
export { ForwardRef as ReactComponent };